const NotAuthorized = () => {
  return <h2>Not Authorized</h2>;
};

export default NotAuthorized;
